export const contentData = {
  spanish:{
    title:null,
    nodata:'Sin Registro',
    error:'Sin registro',
    button:'Agregar',
    form:{
      name:{
        label:'Nombre completo',
        placeholder:'Nombre completo',
      },
      pre_position_id:{
        label:'Puesto',
        placeholder:'Puesto',
      },
      pre_language_id:{
        label:'Idioma',
        placeholder:'Idioma',
      },
      pre_area_id:{
        label:'Área',
        placeholder:'Área',
      },
      pre_country_id:{
        label:'País',
        placeholder:'País',
      },
      client_status_id:{
        label:'Estatus',
        placeholder:'Estatus',
      },
      client_state_id:{
        label:'Estado del proceso',
        placeholder:'Estado del proceso',
      },
      pre_contact_name:{
        label:'Nombre de contacto',
        placeholder:'Nombre de contacto',
      },
      pre_responsible_id:{
        label:'Responsable',
        placeholder:'Responsable',
      },
    },
  },
}